import styled, { css } from 'styled-components';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableCell from '@mui/material/TableCell';
import THEME from '../../constants/theme';

const TableRowRadius = css`
  & > :first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  & > :last-child {
    /* padding-right: 4px; */
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

const StyledTable = styled(Table)`
  &.MuiTable-root {
    ${({ width }) => width && `width: ${width}`};
    ${({ margin }) => margin && `margin: ${margin}`};
    ${({ overflow }) => overflow && `overflow: ${overflow}`};
    min-width: ${({ $minWidth }) => $minWidth || '750px'};
    border-collapse: separate; /**fixes missing border in mozilla */
    padding-right: 4px;

    & .MuiTableCell-root {
      border-bottom: none;
      border-top: 1px solid #e6e9ec;
      transition: all 0.3s ease-out;

      &.MuiTableCell-sizeSmall {
        padding: 9px;
        &.MuiTableCell-head {
          padding-bottom: 16px;
          font-weight: 600;
          background-color: #fff;
        }

        &.MuiTableCell-paddingCheckbox {
          padding-left: 8px;
        }
      }

      &.MuiTableCell-body {
        color: #787f88;
      }
    }
  }
`;

const BreakpointTableCell = styled(TableCell)`
  ${({ breakpoint }) => {
    if (breakpoint === 'visibleDesktopLarge') {
      return `
        @media (max-width: ${THEME.breakPoints.desktopLarge}px) {
          display: none !important;
        }
      `;
    }
    return '';
  }};

  ${({ width }) => width && `width: ${width}`};
`;

/* & .MuiTableCell-root { */

const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    text-transform: uppercase;
    color: #232629;
    position: sticky !important;
    top: 0 !important;
    z-index: 100;

    & .MuiTableRow-root {
      & .MuiTableCell-head {
        border-top: none !important;

        &:hover {
          background-color: ${({ $noDnd }) => ($noDnd ? 'transparent' : THEME.greyColors.grey5)};
        }
      }
    }
  }

  .head-cell {
    min-width: ${({ $tableWidth }) => $tableWidth};
  }
`;

const StyledTableRow = styled(TableRow)`
  opacity: ${({ resolved }) => {
    if (resolved) {
      return 0.5;
    }
    return 1;
  }};
  &.MuiTableRow-root {
    & > :first-child {
      ${({ $checkboxEditMode, $noCheckBox }) => !$checkboxEditMode && !$noCheckBox && 'border-top: none !important'};
    }

    td {
      ${({ $trHeight }) => $trHeight && `height: ${$trHeight}`};
    }

    &:last-child {
      & > td {
        ${({ $checkboxEditMode, $noLastRowBorder }) =>
          !$checkboxEditMode && !$noLastRowBorder && `border-bottom: 1px solid ${THEME.greyColors.grey5}`};

        ${({ $checkboxEditMode }) =>
          !$checkboxEditMode &&
          css`
            &:first-child {
              ${({ $noCheckBox }) => !$noCheckBox && ' border: none'};
              ${({ $lastRowBorder }) => ($lastRowBorder ? `border-top: 1px solid #e6e9ec;` : '')}
            }
          `}
      }
    }

    &.Mui-selected {
      background-color: #fff;
      ${TableRowRadius};

      td,
      th {
        background-color: #f5f6f7;
        border-top-color: transparent;
      }
      + tr td {
        border-top-color: transparent;
      }
    }
    &.MuiTableRow-hover {
      padding: 0 4px;
      cursor: pointer;

      :hover {
        border-radius: 8px;
        background-color: #fff;
        ${TableRowRadius};

        td,
        th {
          background-color: #f5f6f7;
          border-top-color: transparent;
        }
        + tr td {
          border-top-color: transparent;
        }

        td .switchButton {
          display: flex;
        }
      }
    }
  }
`;

const StyledTableSortLabel = styled(TableSortLabel)`
  &.MuiTableSortLabel-root {
    font-size: 12px;
    width: 100%;

    :hover {
      color: #3023c8;
    }

    &.MuiTableSortLabel-active {
      color: #3023c8;
    }

    & .MuiTableSortLabel-icon {
      color: inherit !important;
      display: ${({ $sortable }) => ($sortable ? 'block' : 'none')};
    }
  }
`;

const StyledSortIndicator = styled('span')`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 20px;
  width: 1px;

  & svg {
    padding: 4px 6px 4px 0;
  }
`;

export { StyledTable, StyledSortIndicator, StyledTableHead, StyledTableSortLabel, StyledTableRow, BreakpointTableCell };
